import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Wrench, User } from 'lucide-react';
import { Card } from '../ui/Card';
type ActivityType = 'cleaning' | 'maintenance' | 'access';
type Activity = {
  id: string;
  type: ActivityType;
  description: string;
  timestamp: string;
  person?: string;
};
type ActivityTimelineProps = {
  title: string;
  activities: Activity[];
};
const activityIcons: Record<ActivityType, {
  icon: React.ReactNode;
}> = {
  cleaning: {
    icon: <Sparkles className="w-4 h-4 text-gray-400" data-id="element-117" />
  },
  maintenance: {
    icon: <Wrench className="w-4 h-4 text-gray-400" data-id="element-118" />
  },
  access: {
    icon: <User className="w-4 h-4 text-gray-400" data-id="element-119" />
  }
};
export function ActivityTimeline({
  title,
  activities
}: ActivityTimelineProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.3
  }} data-id="element-120">
      <Card className="p-6" data-id="element-121">
        <h3 className="text-lg font-bold text-navy mb-6" data-id="element-122">{title}</h3>

        <div className="space-y-1" data-id="element-123">
          {activities.map((activity, index) => {
          const {
            icon
          } = activityIcons[activity.type];
          const isLast = index === activities.length - 1;
          return <motion.div key={activity.id} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            delay: 0.4 + index * 0.1
          }} className="relative flex gap-4" data-id="element-124">
                {/* Timeline line */}
                {!isLast && <div className="absolute left-[9px] top-8 w-0.5 h-[calc(100%-8px)] bg-gray-200" data-id="element-125" />}

                {/* Icon - no background */}
                <div className="relative z-10 w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-126">
                  {icon}
                </div>

                {/* Content */}
                <div className="flex-1 pb-5" data-id="element-127">
                  <div className="flex items-start justify-between gap-2" data-id="element-128">
                    <div className="flex-1" data-id="element-129">
                      <p className="text-sm font-medium text-gray-900" data-id="element-130">
                        {activity.description}
                        {activity.person && <span className="text-gray-500" data-id="element-131">
                            {' '}
                            - {activity.person}
                          </span>}
                      </p>
                    </div>
                    <span className="text-xs text-gray-500 whitespace-nowrap" data-id="element-132">
                      {activity.timestamp}
                    </span>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </Card>
    </motion.div>;
}